const fetchResultsStatusSelector = (jobId: string) => (
    state: sage.state.IRedux
): "loading" | "error" | "none" => {
    return state.jobs.resultsLookupStatus[jobId] || "none";
};

export default fetchResultsStatusSelector;
